import { Typography } from '@sonnen/web-ui';
import { parseHtmlTags } from '@sonnen/web-utils';
import { useTranslation } from '../../i18n/i18n';
import styles from './USPTypography.module.css';

type USPTypographyProps = {
  i18nScope:
    | 'selfConsumptionPlus.sonnenAppCard'
    | 'home.cardChart'
    | 'home.cardSmartMeter'
    | 'home.priceOptimizationTeaserCard'
    | 'tariffOverview.energyFix.cardSonnenApp'
    | 'tariffOverview.energyFix.cardPredictableCosts'
    | 'selfConsumptionPlus.usp1'
    | 'selfConsumptionPlus.usp2';
  variant?: 'primary' | 'on-colour';
  header?: 'H2' | 'H4';
};

/**
 * Show title in H2 and text from i18n scope. Useful for USP cards.
 */
export const USPTypography = ({
  i18nScope,
  variant = 'primary',
  header = 'H2',
}: USPTypographyProps) => {
  const { t } = useTranslation();
  const title = t(`${i18nScope}.title`);
  const text = t(`${i18nScope}.text`);
  const HeaderComp = header === 'H2' ? Typography.H2 : Typography.H4;
  return (
    <span className={styles.uspTypography}>
      <HeaderComp variant={variant}>{title}</HeaderComp>
      <Typography.Body1 variant={variant}>
        <span>{parseHtmlTags(text)}</span>
      </Typography.Body1>
    </span>
  );
};
